import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { textActions } from '../actions/text.actions';
import { selectLoading, selectText } from '../selectors/text.selector';

@Injectable({
    providedIn: 'root',
})
export class TextFacade {
    private store = inject(Store);

    readonly text$ = (id: string) => this.store.select(selectText(id));
    readonly textNonNullable$ = (id: string) => this.store.select(selectText(id)).pipe(filter((text) => text !== null));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));

    getText(id: string): void {
        this.store.dispatch(textActions.getText({ id }));
    }

    clear(): void {
        this.store.dispatch(textActions.clear());
    }
}
